import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

export enum ButtonGroupRender {
  Inline = 'inline',
  Block = 'block'
}

@Component({
  selector: 'app-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ButtonGroupComponent implements OnInit {
  @Input()
  render = ButtonGroupRender.Inline;

  constructor() { }

  ngOnInit() {
  }

}
